import React from 'react';
class SlickCarousel extends React.Component {
  constructor(props) {
    super(props);

    const { id, children, slickSettings } = props;

    this.state = {
      id,
      children,
      slickSettings,
    };
  }

  componentDidMount() {
    const { id, slickSettings } = this.props;

    $(`#${id}`).slick(slickSettings);
  }

  componentWillUnmount() {
    const { id } = this.props;
    const $slider = $(`#${id}`);

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }

  render() {
    const { id } = this.state;

    return (
      <div className="carousel-container">
        <div id={id} className="slick-carousel text-center mb-2">
          {this.renderSlides()}
        </div>
        {this.renderMessage()}
      </div>
    );
  }

  renderMessage = () => {
    const { responseMessage } = this.props;

    if (!responseMessage) {
      return null;
    }

    return (
      <div className="add-to-cart-update w-75 m-auto p-2">
        <i className="fas fa-cart-plus mr-2"></i>
        {responseMessage}
      </div>
    );
  };

  renderSlides = () => {
    const { children } = this.state;

    const carouselItems = children.map((item, i) => {
      return <div key={`carouselItem_${i}`}>{item}</div>;
    });

    return carouselItems;
  };
}

export default SlickCarousel;
